import { BrowserRouter } from 'react-router-dom';
import { Provider } from "react-redux";
import ReduxToastr from 'react-redux-toastr';
import ReactGA from "react-ga";

import AppRoutes from './client/js/router/AppRoutes';
import store from './client/js/store/store';
import AnalyticsListener from "./analytics/AnalyticsListener";
import { AuthProvider } from "./context/AuthContext";

//* Enables Google Analytics just for the PROD server
const trackingId = process.env.NODE_ENV === 'production' && process.env.REACT_APP_GAtrackingId
if (trackingId) {
    ReactGA.initialize(trackingId);
}

const App = () => {
    return (
        <Provider store={store}>
            <AuthProvider>
                <BrowserRouter>
                    {trackingId && <AnalyticsListener />}
                    <AppRoutes />
                </BrowserRouter>
                <ReduxToastr
                    timeOut={5000}
                    newestOnTop={false}
                    preventDuplicates
                    position="top-right"
                    transitionIn="fadeIn"
                    transitionOut="fadeOut"
                />
            </AuthProvider>
        </Provider>
    )
}

export default App;
